/**
 * Telemetria de aquisição do PRO — F0 do Roadmap PRO (11/09).
 *
 * Ponto único para `pro_cta_click`. São mais de uma dezena de lugares que
 * navegam para `/pro`; se cada um chamasse `track()` com a string do evento à
 * mão, o primeiro ajuste (renomear o evento, trocar uma prop) divergiria em
 * onze cópias — a mesma doença que `purchaseAvailability.ts` já resolveu para
 * o gate de plataforma. Todo novo ponto de entrada para `/pro` deve chamar
 * esta função em vez de `track("pro_cta_click", ...)` direto.
 */

import { track, trackOncePerSession } from "../../lib/telemetry";

/** De onde a pessoa veio ao tocar num convite para o PRO. Um valor por site novo. */
export type ProCtaOrigin =
  | "global_header"
  | "settings"
  | "store_shop_tab"
  | "focus_mode_modal"
  | "profile_own"
  | "public_profile"
  | "public_profile_league_upsell"
  | "home_header"
  | "match"
  | "pro_lapse_modal"
  | "pro_teaser_modal"
  | "lura_pro_card"
  | "home_lura_rail_lock"
  | "friends_league_tab"
  | "insights_hero"
  | "pro_layer_section"
  | "theme_preview_bar"
  | "founder_landing"
  | "checkout_canceled_retry"
  | "sobre_page"
  | "founder_upsell_section"
  | "public_reading_page_own"
  /** Folha pós-onboarding: o botão de começar o teste. */
  | "onboarding_offer"
  /** Folha pós-onboarding: "e mais N benefícios" → `/pro`. */
  | "onboarding_offer_more"
  /** Estatísticas v2 (26/09): a seção "Você e o Livra" do free. */
  | "stats_compare"
  /** Estatísticas v2 (26/09): a tela do PRO dentro da retrospectiva. */
  | "stats_recap"
  /** Wrap anual (fatia 5): a comparação do ano, no free. */
  | "stats_wrap"
  /** Faixa de campanha da Home (`HomeBannerStrip`, autorada no `/admin`) apontando para `/pro`. */
  | "home_banner"
  /** Card "Tema da sua leitura" no miolo da Home (A1, `ProReadingThemeCard`). */
  | "home_pro_card"
  /** "Chamar para um clube" num cartão de Leitores parecidos (Free, depois de seguir). */
  | "people_suggestions"
  /** Convidada não-PRO dentro de uma liga privada alheia (D7, mock `liga-clube`). */
  | "league_club_guest"
  /** Dona sem PRO no clube do livro: "Assinar e abrir o próximo" (mock 4c). */
  | "league_club_owner";

export function trackProCtaClick(origin: ProCtaOrigin): void {
  track("pro_cta_click", { origin });
}

/**
 * Impressão de um convite — `pro_nudge_view` (estudo de divulgação do PRO,
 * 26/09). Sem impressão não existe taxa de toque: "ninguém vê a capa trancada"
 * ficava indistinguível de "veem e ignoram" (a capa começa FORA da tela em
 * 390 px). Uma por origem por sessão do navegador, pelo mesmo
 * `trackOncePerSession` do `affiliate_impression` — é o denominador, não uma
 * contagem de renders. `trial` diz se a porta prometeu teste (a variável que
 * a fatia 1 muda).
 */
export function trackProNudgeView(origin: ProCtaOrigin, trialDays: number | null): void {
  trackOncePerSession("pro_nudge_view", origin, { origin, trial: trialDays !== null && trialDays > 0 });
}
